import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { theme } from 'antd';
import { RootState } from '../../app/store';
import { MappingAlgorithm } from 'antd/lib';

interface IState {
  theme: MappingAlgorithm | MappingAlgorithm[] | undefined;
}

const initialState: IState = {
  theme:
    localStorage.getItem('theme') === 'defaultTheme'
      ? theme.darkAlgorithm
      : theme.defaultAlgorithm,
};
const themeSlice = createSlice({
  name: 'themeSlice',
  initialState,
  reducers: {
    setTheme(
      state,
      action: PayloadAction<MappingAlgorithm | MappingAlgorithm[] | undefined>
    ) {
      state.theme = action.payload;
      if (state.theme === theme.darkAlgorithm) {
        localStorage.setItem('theme', 'defaultTheme');
      } else if (state.theme === theme.defaultAlgorithm) {
        localStorage.setItem('theme', 'darkTheme');
      }
    },
  },
});

export const { setTheme } = themeSlice.actions;

export const globalTheme = (state: RootState) => state.themeSlice;

export default themeSlice.reducer;
